import { createFileRoute, redirect } from '@tanstack/react-router';
import { checkRoutePermission } from '@/components/Auth/checkUserPermissions';
import { StudentImport } from '@/components/Import/StudentImport';
import { importSearchSchema } from '@/components/Import/importSearchSchema';
import type { SearchFilter } from '@/types/filterSearch';

export const Route = createFileRoute(
  '/$tenantId/_layout/students/child-and-youth/import',
)({
  component: ChildAndYouthImportRoute,
  validateSearch: importSearchSchema,
  beforeLoad: ({ params }) => {
    const hasPermission = checkRoutePermission({
      permission: 'organization:editor',
    });
    if (!hasPermission) {
      throw redirect({ to: '/$tenantId', params });
    }
  },
});

function ChildAndYouthImportRoute() {
  const { tenantId } = Route.useParams();
  const searchParams = Route.useSearch() as ReturnType<typeof Route.useSearch> &
    SearchFilter;

  return (
    <StudentImport
      formType="child-and-youth"
      tenantId={tenantId}
      searchParams={searchParams}
    />
  );
}
